package com.essntl.core.utils.utils

fun String.capitalizeFirstLetter(): String {
    return this.split(Regex("\\b")).joinToString("") {
        it.replaceFirstChar { char -> char.titlecase() }
    }
}

fun String.capitalise(): String {
    return this.lowercase()
        .replaceFirstChar {
            if (it.isLowerCase()) it.titlecase() else
                it.toString()
        }
}

fun String.sanitizeFileName(): String =
    replace(" ", "_").replace("-", "_")

inline fun String?.letIfNotEmpty(block: (String) -> Unit) {
    if (!this.isNullOrEmpty()) {
        block(this)
    }
}